import React from "react";
import styled from 'styled-components'

const status = {
  status: String
}

const changeStatus = (status, theme) => {
  switch (status) {
    case 'ERROR':
    case 'FAIL':
    case 'REJECT':
    case 'RED':
    case 'PAYMENT_FAIL':
    case 'PAYOUT_FAIL':
      return `
        background: ${theme.status.danger};
      `;
    case 'PENDING':
    case 'CONSIDERATION':
    case 'YELLOW':
    case 'DEBUG':
    case 'PAYMENT_PENDING':
    case 'PAYOUT_PENDING':
    case 'AML_CHECKING':
    case 'WAITING':
    case 'NEED_CONFIRMATION':
      return `
        background: ${theme.status.warning};
      `;
    case 'PROCESSED':
    case 'APPROVE':
    case 'GREEN':
    case 'PAYMENT_PROCESSED':
    case 'EXCHANGE_PROCESSED':
    case 'ACTIVE':
    case 'PAID':
      return `
        background: ${theme.status.success};
      `;
    case 'FROZEN':
      return `
        background: ${theme.status.frozen};
      `;
    case 'CANCELLED':
      return `
        background: ${theme.status.cancelled};
      `;
    default:
      return `
        background: ${theme.status.default};
      `;
  }
}

export const StyledStatus = styled('div', status)`
  ${({minWidth}) => minWidth ? `min-width: ${minWidth}px` : `min-width: 90px`};
  padding: 2px 15px;
  color: ${({theme}) => theme.status.color};
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  text-transform: capitalize;
  border-radius: 30px;
  display: inline-grid;
  ${({status, theme}) => changeStatus(status, theme)};
`;

const RenderStatus = ({as, status, minWidth}) => {
  return (
    <StyledStatus as={as} status={status} minWidth={minWidth}>
      {status?.toLowerCase().replace(/_/g, " ")}
    </StyledStatus>
  )
}

export default RenderStatus;